/* eslint-disable no-param-reassign */
import axios from 'axios';
import { store } from 'store/index';
import {
  LOGOUT,
  REFRESH_TOKEN,
  // REFRESHING_TOKEN,
} from 'store/reducers/auth';
import { CLEAR } from 'store/reducers/catalogs';
import { CLEAN } from 'store/reducers/app';
import jwt_decode from 'jwt-decode';
import { CLEAN_CAJA } from 'store/reducers/caja';
import { CLEAN_DASHBOARD } from 'store/reducers/dashboard';
// import { formatPredioKeyProp } from 'views/Catastro/utils/onBlurKey';

export const {
  REACT_APP_SCHEME: SCHEME,
  REACT_APP_APIHOST: APIHOST,
  REACT_APP_PATH: PATH,
} = process.env;

export const baseURL = `${SCHEME}://${APIHOST}${PATH}`;

const defaultOptions = {
  baseURL,
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json',
  },
};
/**
 * Asegura que una cadena tenga un prefijo específico.
 * Si la cadena ya comienza con el prefijo, la retorna sin modificarla.
 *
 * @param {string} prefix - El prefijo que debe tener la cadena.
 * @param {*} s - El valor a procesar (se convierte a string automáticamente).
 * @returns {string} La cadena con el prefijo garantizado.
 *
 * @example
 * ensurePrefixed('/api', 'usuarios')  // → '/apiusuarios'
 * ensurePrefixed('/api', '/api/usuarios')  // → '/api/usuarios'
 */
export const ensurePrefixed = (prefix, s) => {
  const v = String(s || '').trim();
  return v.startsWith(prefix) ? v : `${prefix}${v}`;
};
/**
 * Infiere un nombre de acción en formato VERBO_RECURSO a partir
 * del método HTTP y la URL de una petición.
 *
 * Los métodos soportados son:
 * - POST   → CREAR
 * - PATCH  → EDITAR
 * - PUT    → EDITAR
 * - DELETE → ELIMINAR
 *
 * Los segmentos numéricos de la URL se ignoran para extraer
 * el nombre del recurso (e.g. `/usuarios/42` → `USUARIOS`).
 *
 * @param {string} method - Método HTTP (post, patch, put, delete).
 * @param {string} url    - URL de la petición (puede incluir IDs numéricos).
 * @returns {string|null} Cadena con formato "VERBO_RECURSO",
 *                        o `null` si el método no está soportado.
 *
 * @example
 * inferAccion('post',   '/api/usuarios')      // → 'CREAR_USUARIOS'
 * inferAccion('delete', '/api/usuarios/42')   // → 'ELIMINAR_USUARIOS'
 * inferAccion('patch',  '/api/blog-posts/5')  // → 'EDITAR_BLOG_POSTS'
 * inferAccion('get',    '/api/usuarios')      // → null
 */
const inferAccion = (method, url) => {
  const verbMap = {
    post: 'CREAR', patch: 'EDITAR', put: 'EDITAR', delete: 'ELIMINAR',
  };
  const verb = verbMap[method?.toLowerCase()];
  if (!verb) return null;
  const cleanUrl = url.replace(/\/\d+/g, '').replace(/\/$/, '');
  const parts = cleanUrl.split('/').filter(Boolean);
  const resource = parts[parts.length - 1]?.toUpperCase().replace(/-/g, '_') || 'RECURSO';
  return `${verb}_${resource}`;
};

const HTTP = axios.create(defaultOptions);
export const createEmptyAxiosInstance = (withBaseConfig = true) => axios
  .create(withBaseConfig ? defaultOptions : null);

export const logout = () => {
  setTimeout(() => {
    store.dispatch({ type: CLEAN });
    store.dispatch({ type: CLEAR });
    store.dispatch({ type: CLEAN_CAJA });
    store.dispatch({ type: CLEAN_DASHBOARD });
    store.dispatch({ type: LOGOUT });
  });
};

// const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// const waitForToken = async (old, url) => {
//   const { refreshToken } = store.getState().auth;
//   console.log(url, ' [refreshToken === old] ', refreshToken === old);
//   // token still the same, wait
//   if (refreshToken === old) {
//     await wait(500);
//     return waitForToken(old, url);
//   }
//   // token was refreshed
//   return refreshToken;
// };

const refreshToken = async () => {
  try {
    const { refreshToken: refresh } = store.getState().auth;
    // const { refreshingToken } = store.getState().auth;
    // if (refreshingToken) {
    //   const _token = await waitForToken(refresh, url);
    //   return _token;
    // }
    // store.dispatch({ type: REFRESHING_TOKEN, payload: true });
    const response = await HTTP.post('usuarios/refresh-token/', { refresh });
    store.dispatch({ type: REFRESH_TOKEN, payload: response.data.access });
    // store.dispatch({ type: REFRESHING_TOKEN, payload: false });
    return response.data.access;
  } catch (err) {
    return null;
  }
};

const requestInterceptor = async (options) => {
  // if (options?.params) {
  //   formatPredioKeyProp(options.params);
  // }

  // if (options?.data) {
  //   formatPredioKeyProp(options.data);
  // }

  if (!options.url.includes('refresh-token')) {
    let { token } = store.getState().auth;
    if (token) {
      const decoded = jwt_decode(token);
      const current = new Date();
      const expiration = new Date(decoded.exp * 1000);
      const isExpired = current.getTime() >= expiration.getTime();
      if (isExpired) {
        token = await refreshToken(options.url);
      }
      options.headers.Authorization = token ? `Bearer ${token}` : null;
    }

    const accionInf = options.accionInf || inferAccion(options.method, options.url);
    const { id_padron, clave } = options;
    delete options.accionInf;
    delete options.id_padron;
    delete options.clave;
    if (options.data) {
      const injectField = (key, value) => {
        if (value == null) return;
        if (options.data instanceof FormData) {
          options.data.append(key, value);
        } else if (typeof options.data === 'object') {
          options.data[key] = value;
        }
      };
      if (accionInf) injectField('accionInf', accionInf);
      injectField('idPadron', id_padron);
      injectField('clave', clave);
    }
  }
  if (options.url[options.url.length - 1] !== '/') {
    options.url = `${options.url}/`;
  }
  return options;
};

HTTP.interceptors.request.use(requestInterceptor);

const errorResponseInterceptor = async (err) => {
  const inRefreshToken = err?.config?.url === 'usuarios/refresh-token/';
  if (err?.response && !inRefreshToken) {
    const { response: { data, status } } = err;
    if (data && status === 401) {
      const errorDetail = data.code === 'token_not_valid';
      if (errorDetail) {
        const token = await refreshToken();
        if (token) {
          const config = { ...err.config };
          config.headers.Authorization = `Bearer ${token}`;
          store.dispatch({ type: REFRESH_TOKEN, payload: token });
          return axios.request(config);
        }
        logout();
      }
    }
  } else if (inRefreshToken) {
    logout();
  }
  if (err.response?.status === 502 || err.code === 'ERR_NETWORK') {
    return axios.request(err.config);
  }
  return Promise.reject(err);
};

HTTP.interceptors.response.use(null, errorResponseInterceptor);

HTTP.tryCancel = () => {
  if (HTTP.source?.cancel) {
    HTTP.source.cancel();
  }
};

export default HTTP;
